import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

import { PublicLayout } from "./components/layout/PublicLayout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Book from "./pages/Book";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Terms from "./pages/Terms";
import CancelAppointment from "./pages/CancelAppointment";
import RescheduleAppointment from "./pages/RescheduleAppointment";
import ManageAppointment from "./pages/ManageAppointment";
import KapperUtrecht from "./pages/KapperUtrecht";
import AfspraakMaken from "./pages/AfspraakMaken";
import NotFound from "./pages/NotFound";

import { ProtectedRoute } from "./components/admin/ProtectedRoute";
import { AdminLayout } from "./components/admin/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminResetPassword from "./pages/admin/AdminResetPassword";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCalendar from "./pages/admin/AdminCalendar";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminAvailability from "./pages/admin/AdminAvailability";
import AdminServices from "./pages/admin/AdminServices";
import AdminPhotos from "./pages/admin/AdminPhotos";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminReports from "./pages/admin/AdminReports";
import AdminSettings from "./pages/admin/AdminSettings";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="/diensten" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/boeken" element={<Book />} />
              <Route path="/privacybeleid" element={<Privacy />} />
              <Route path="/cookiebeleid" element={<Cookies />} />
              <Route path="/algemene-voorwaarden" element={<Terms />} />
              <Route path="/afspraak-annuleren" element={<CancelAppointment />} />
              <Route path="/afspraak-wijzigen" element={<RescheduleAppointment />} />
              <Route path="/mijn-afspraak" element={<ManageAppointment />} />
              <Route path="/kapper-utrecht" element={<KapperUtrecht />} />
              <Route path="/afspraak-maken" element={<AfspraakMaken />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="agenda" element={<AdminCalendar />} />
              <Route path="boekingen" element={<AdminBookings />} />
              <Route path="beschikbaarheid" element={<AdminAvailability />} />
              <Route path="diensten" element={<AdminServices />} />
              <Route path="fotos" element={<AdminPhotos />} />
              <Route path="berichten" element={<AdminMessages />} />
              <Route path="rapportage" element={<AdminReports />} />
              <Route path="instellingen" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
